import { z } from 'zod';
import { isoDate } from './common.js';
import { EMPTY_WEEK_FILTERS } from '../logic/deployment-week.js';
export const deploymentWeekQuerySchema = z.object({
    week: isoDate.optional(),
    search: z.string().optional(),
    projectId: z.string().uuid().optional(),
    workerId: z.string().uuid().optional(),
});
export function weekDescriptorFromQuery(q, fallbackWeek) {
    return {
        weekStart: q.week ?? fallbackWeek,
        filters: {
            ...EMPTY_WEEK_FILTERS,
            search: q.search ?? '',
            projectId: q.projectId ?? '',
            workerId: q.workerId ?? '',
        },
    };
}
//# sourceMappingURL=deployment-week.js.map